export const FIELD_LABELS: Readonly<Record<string, string>> = {
  firstName: "patients.firstName",
  middleName: "patients.middleName",
  lastName: "patients.lastName",
  phone: "patients.phone",
  whatsapp: "patients.whatsapp",
  dateOfBirth: "patients.dateOfBirth",
  gender: "patients.gender",
  address: "patients.address",
  email: "users.email",
  patientId: "appointments.patient",
  newPatient: "appointments.patient",
  doctorId: "appointments.doctor",
  startsAt: "appointments.date",
  durationMinutes: "appointments.duration",
  type: "appointments.type",
  reason: "appointments.reason",
  notes: "appointments.notes",
  procedureId: "chart.panel.procedure",
  status: "chart.panel.status",
  price: "chart.panel.price",
  discount: "chart.panel.discount",
  discountReason: "chart.panel.discountReason",
  chartMarks: "visits.teeth",
  visitDate: "visits.date",
  expectedAt: "labs.order.expected",
  expiryDate: "inventory.movement.expiry",
};
